module.exports = __webpack_public_path__ + "static/media/20ECE21.4577bea9.jpg";